import { render, staticRenderFns } from "./TotalCompletion.vue?vue&type=template&id=08bc4d03"
import script from "./TotalCompletion.vue?vue&type=script&lang=js"
export * from "./TotalCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports